import React, { useEffect } from "react"
import { useLocationFilters } from "../../hooks/search/useLocationfilters"

export default function LocationFilters({ location, setLocation }) {
  const {
    estado,
    setEstado,
    municipio,
    setMunicipio,
    parroquia,
    setParroquia,
    estados,
    municipios,
    parroquias,
  } = useLocationFilters(location)

  useEffect(() => {
    setLocation && setLocation({ estado, municipio, parroquia })
  }, [estado, municipio, parroquia]) // eslint-disable-line

  return (
    <div className="grid md:grid-cols-3 gap-3">
      <select
        className="border rounded p-2"
        value={estado}
        onChange={(e) => {
          setEstado(e.target.value)
          setMunicipio("")
          setParroquia("")
        }}
      >
        <option value="">Estado</option>
        {estados.map((e) => (
          <option key={e} value={e}>
            {e}
          </option>
        ))}
      </select>

      <select
        className="border rounded p-2"
        value={municipio}
        onChange={(e) => {
          setMunicipio(e.target.value)
          setParroquia("")
        }}
        disabled={!estado}
      >
        <option value="">Municipio</option>
        {municipios.map((m) => (
          <option key={m} value={m}>
            {m}
          </option>
        ))}
      </select>

      <select
        className="border rounded p-2"
        value={parroquia}
        onChange={(e) => setParroquia(e.target.value)}
        disabled={!municipio}
      >
        <option value="">Parroquia</option>
        {parroquias.map((p) => (
          <option key={p} value={p}>
            {p}
          </option>
        ))}
      </select>
    </div>
  )
}
